import { render, staticRenderFns } from "./NormalLogin.vue?vue&type=template&id=06d67fe5&scoped=true"
import script from "./NormalLogin.vue?vue&type=script&lang=js"
export * from "./NormalLogin.vue?vue&type=script&lang=js"
import style0 from "./NormalLogin.vue?vue&type=style&index=0&id=06d67fe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d67fe5",
  null
  
)

export default component.exports